import React, { Suspense } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Spinner from './components/Spinner';
import SidebarController from './components/Sidebar/SidebarController';
import AuthenticatedRouter from './authenticate/AuthenticatedRouter';
import FlashMessage from './components/FlashMessage';
import {
  InvestmentFinanceRoutes,
  PrivacyPolicyPath,
  CookiePolicyPath,
  rootPath,
  SettlementFinanceRoutes,
  TermsAndConditionsPath,
} from './constants/routes';
import { OverlayProvider } from './context/overlay';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import AuthHandler from './authenticate/auth-handler';

const ProductOffer = React.lazy(() => import('./pages/ProductOffer'));
const SFRoutes = React.lazy(() => import('./routes/settlementfinance'));
const IFRoutes = React.lazy(() => import('./routes/investmentfinance'));
const TermsAndConditions = React.lazy(
  () => import('./pages/InvestmentFinance/TermsAndConditions'),
);
const UnauthorisedView = React.lazy(() => import('./pages/UnauthorisedView'));

interface Props {
  selectedLanguage: string;
}

const App: React.FC<Props> = ({ selectedLanguage }) => (
  <Router key={selectedLanguage}>
    <Suspense fallback={<Spinner />}>
      <FlashMessage>
        <OverlayProvider>
          <Switch>
            {/* Public routes - accessible without authentication */}
            <Route exact path={PrivacyPolicyPath} component={PrivacyPolicy} />
            <Route exact path={CookiePolicyPath} component={CookiePolicy} />

            {/* Protected routes - require authentication */}
            <Route path="/">
              <AuthHandler>
                <AuthenticatedRouter>
                  <SidebarController>
                    <Switch>
                      <Route
                        path={SettlementFinanceRoutes.basePath}
                        component={SFRoutes}
                      />
                      <Route
                        path={InvestmentFinanceRoutes.basePath}
                        component={IFRoutes}
                      />
                    </Switch>
                  </SidebarController>
                  <Switch>
                    <Route exact path={rootPath} component={ProductOffer} />
                    <Route
                      exact
                      path={TermsAndConditionsPath}
                      component={TermsAndConditions}
                    />
                    <Route path="*" component={UnauthorisedView} />
                  </Switch>
                </AuthenticatedRouter>
              </AuthHandler>
            </Route>
          </Switch>
        </OverlayProvider>
      </FlashMessage>
    </Suspense>
  </Router>
);

export default App;
